import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class newsletterInteractionEmailView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return (`

            <div class="w-form w-form-large w-form-article-view">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditNewsletterInteractionEmail }, visible: permissions()['newsletter_interaction_emails'].read" class="btn icon i-edit"  type="button">Edit Newsletter Interaction Email</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Subject</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: subject"></span>
                                </dd>
                                <dt>
                                    <span>Preview Text</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: previewText"></span>
                                </dd>
                                <dt>
                                    <span>Type</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: type"></span>
                                </dd>
                                <dt>
                                    <span>Template</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: template"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Content</strong>
                    </div>
                </div>
                
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group form-group-content">
                                    <p data-bind="html: content"></[span]>
                         </div>
                    </div>
                    
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Signature</strong>
                    </div>
                </div>
                
                <div class="w-form-body">
                   
                    <div class="w-form-body">
                    
                        <div class="form-body">
                            <div class="form-group form-group-content">
                                        <p data-bind="html: signature"></[span]>
                            </div>
                        </div>
                        
                    </div>                    
                </div>
                
            </div>
        `);
    }

    protected buildViewModel(): any {

        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            type: ko.observable(""),
            template: ko.observable(""),
            content: ko.observable(""),
            signature: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_interaction_emails'])),
            onClickEditNewsletterInteractionEmail: function (data, event) {
                self.onClickEditNewsletterInteractionEmail(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
        }
    }

    protected getTemplateName(): string {

        return "newsletterInteractionEmailView_template";
    }

    protected onClickEditNewsletterInteractionEmail(id: any): any {

        this.caller.onClickEditNewsletterInteractionEmail(id)
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel()
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    protected setNewsletterInteractionEmailData(newsletterInteractionEmail) {

        this.getTemplateViewModel().id(newsletterInteractionEmail.id);
        this.getTemplateViewModel().subject(newsletterInteractionEmail.subject);
        this.getTemplateViewModel().previewText(newsletterInteractionEmail.previewText);
        this.getTemplateViewModel().type(newsletterInteractionEmail.type.name);
        this.getTemplateViewModel().template(newsletterInteractionEmail.template.name);
        this.getTemplateViewModel().content(newsletterInteractionEmail.content);
        this.getTemplateViewModel().signature(newsletterInteractionEmail.signature);
        this.getTemplateViewModel().dateCreated(newsletterInteractionEmail.dateCreated);
        this.getTemplateViewModel().dateUpdated(newsletterInteractionEmail.dateUpdated);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/newsletterInteractionEmailView_template.ts